import React, { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

// Round button, bottom right. Appears once the visitor has scrolled down a screen or so.
export default function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTop = () => {
    const reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    window.scrollTo({ top: 0, behavior: reduce ? "auto" : "smooth" });
  };

  return (
    <button type="button" className={`to-top${show ? " show" : ""}`} onClick={goTop}
      aria-label="Back to top" tabIndex={show ? 0 : -1} data-testid="back-to-top">
      <ArrowUp size={20} strokeWidth={2.4} />
    </button>
  );
}
